import React from "react";
import { Route as ReactDOMRoute,
    RouteProps as ReactDOMRouteProps, 
    Redirect 
} from "react-router-dom";

import { useAuth } from "../hooks/Auth";

interface RouteProps extends ReactDOMRouteProps{
    isPrivate?: boolean;
    component: React.ComponentType,
}


const Route: React.FC<RouteProps> = ({isPrivate = false, component: Component, ...rest }) => {
    const { user } = useAuth();
    return (
        <ReactDOMRoute
            {...rest}
            render={({location}) => {
                return isPrivate === !!user ? (
                    <Component />
                ) : (
                    <Redirect to={{ 
                        pathname: isPrivate ? '/' : '/dashboard', 
                        state: {from: location},
                     }}
                    />
                );
            }}
        />
    )
}

export default Route;

/* SCRIPT ANTIGO 
import React from 'react';
import { 
    Route as ReactDOMRoute,
    RouteProps as ReactDOMRouteProps, 
    Redirect 
} from 'react-router-dom';


interface RouteProps  extends ReactDOMRouteProps{
    path: string,
    exact?: boolean,    
    component: React.ComponentType,
    isPrivate?: boolean,
}

const Route: React.FC<RouteProps> = ({
    component: Component,
    isPrivate = false,
    ...rest
}) => {
    const signed = false;

    if(!signed && isPrivate){
        return <Redirect to='/' />;
    }

    if(signed && !isPrivate){
        return <Redirect to='/dashboard' />;
    }

    return(
        <ReactDOMRoute {...rest} component={Component} />
    )
}

export default Route;
*/